import { omit } from "lodash";

export type PrintFormatData = Omit<PrintFormat, 'data'>;

function mergeArrays<T>(arr1: Array<T>, arr2: Array<T>) {
    const maxLength = Math.max(arr1.length, arr2.length);
  
    return Array.from({ length: maxLength }, (_, i) => [
      arr1[i],
      arr2[i],
    ]);
}

interface PriceLevel {
    from: number|null;
    price: number|null;
}

export class PrintFormat {
    public priceLevels: Array<{ from: number|null; price: number|null }> = [];

    constructor(public name: string, public price: number|null, public id?: string) {}

    get clone() {
        const clone = new PrintFormat(this.name, this.price);
        clone.priceLevels = this.priceLevels.map(p => ({ ...p }));

        return clone;
    }

    get data(): PrintFormatData {
        return omit<PrintFormat, 'data'>(this, 'data');
    }

    public equals(format: PrintFormat) {
        const sortPriceLevels = (levels: Array<PriceLevel>) => [...levels].sort((a, b) => (b.from || 0) - (a.from || 0));
        const priceLevelsEqual = (a?: PriceLevel, b?: PriceLevel) => 
            !!a && !!b && 
            Number(a.from) === Number(b.from) && 
            Number(a.price) === Number(b.price);

        return this.name === format.name &&
            Number(this.price) === Number(format.price) &&
            this.id === format.id &&
            mergeArrays(
                sortPriceLevels(this.priceLevels),
                sortPriceLevels(format.priceLevels)
            ).reduce((prev, [a, b]) => prev && priceLevelsEqual(a, b), true)
    }

    static fromData(data: any) {
        const format = new this(data.name, data.price, data.id);
        format.priceLevels = [ ...data.priceLevels ].sort(({from: a}, {from: b}) => a - b);

        return format;
    }
}